"use client";

import { useQuery } from "@tanstack/react-query";

import { env } from "@/env";

const BASE_URL = env.NEXT_PUBLIC_API_URL;

interface ClaimsListResponse {
  claimedWeeks: number[];
}

export function cardvaultClaimsQueryKey(owner: string | undefined) {
  return ["cardvault-claims", owner] as const;
}

export function useCardvaultClaims(owner: string | undefined) {
  return useQuery({
    queryKey: cardvaultClaimsQueryKey(owner),
    queryFn: async (): Promise<ClaimsListResponse> => {
      if (!owner) return { claimedWeeks: [] };
      const res = await fetch(`${BASE_URL}/api/card-vault/claims/${owner}`);
      if (!res.ok) return { claimedWeeks: [] };
      return res.json() as Promise<ClaimsListResponse>;
    },
    enabled: !!owner,
    staleTime: 30_000,
  });
}
